module.exports = __webpack_public_path__ + "static/img/skip.a366ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/skip/img/skip.png
// module id = KIi2
// module chunks = 1